import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { AppDispatch } from "src";
import { useDispatch, useSelector } from "react-redux";
import { deleteUnit, getUnits, updateUnit } from "src/slices/thunks";

const ModalValidation = ({
  selectedUnit,
  setModal,
  setSuccessDelete,
  setErrorDelete,
  setSuccessUpdate,
  setErrorUpdate,
}: any) => {
  const dispatch = useDispatch<AppDispatch>();
  // Form validation
  const validation = useFormik({
    initialValues: {
      name: `${selectedUnit.name}`,
      parent: `${selectedUnit.parent}`,
      type: `${selectedUnit.type}`,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor, insira o nome completo"),
      parent: Yup.string().required("Por favor, insira o parent"),
      type: Yup.string().required("Por favor, insira a função"),
    }),

    onSubmit: values => {
      dispatch(updateUnit({ ...values, id: selectedUnit.id })).then(
        response => {
          setModal(false);
          if (
            typeof response.payload === "string" &&
            response.payload.includes("Request failed with")
          ) {
            setErrorUpdate(true);
          } else {
            setSuccessUpdate(true);
          }
        }
      );
    },
  });

  const handleDelete = () => {
    dispatch(deleteUnit(selectedUnit.id)).then(response => {
      setModal(false);
      if (
        typeof response.payload === "string" &&
        response.payload.includes("Request failed with")
      ) {
        setErrorDelete(true);
      } else {
        setSuccessDelete(true);
        dispatch(getUnits());
      }
    });
  };
  const units = useSelector((state: any) =>
    state.units.units.filter((unit: any) => unit.id !== selectedUnit.id)
  );
  const unitsTypes = useSelector((state: any) => state.unitsTypes.units);

  return (
    <React.Fragment>
      <Form
        className="needs-validation"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom01">Nome</Label>
            <Input
              name="name"
              placeholder="Nome"
              type="text"
              className="form-control"
              id="validationCustom01"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.touched.name && validation.errors.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom03">Superior</Label>
            <Input
              name="parent"
              placeholder="Superior"
              type="select"
              className="form-control"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.parent || ""}
              invalid={
                validation.touched.parent && validation.errors.parent
                  ? true
                  : false
              }
            >
              <option value="">Selecione</option>
              {units.map((unit: any) => (
                <option value={unit.id} key={unit.id}>
                  {unit.name}
                </option>
              ))}
            </Input>
            {validation.touched.parent && validation.errors.parent ? (
              <FormFeedback type="invalid">
                {validation.errors.parent}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom04">Tipo</Label>
            <Input
              name="type"
              placeholder="Função"
              type="select"
              className="form-control"
              id="validationCustom04"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.type || ""}
              invalid={
                validation.touched.type && validation.errors.type ? true : false
              }
            >
              <option value="">Selecione</option>
              {unitsTypes.map((unitType: any) => (
                <option value={unitType.id} key={unitType.id}>
                  {unitType.name}
                </option>
              ))}
            </Input>
            {validation.touched.type && validation.errors.type ? (
              <FormFeedback type="invalid">
                {validation.errors.type}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
        <div className="d-flex flex-wrap gap-2">
          <Button color="primary" type="submit">
            Submiter
          </Button>
          <Button type="button" color="danger" onClick={handleDelete}>
            Apagar
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default ModalValidation;
